import { RefObject, useState } from "react";
import { useTradeHistoryTableQuery } from "src/api/client/trade/trade-history.api";
import { useEnclosingJumpMarkSection } from "src/components-mui/common/jump-marks/jump-mark-section";
import { useScrollToSection } from "src/components-mui/common/jump-marks/jump-marks.context";
import { useIsSectionInView } from "src/components-mui/common/jump-marks/use-is-section-in-view";

export const useTradeHistoryTable = (wikifolioId: string, sectionRef: RefObject<HTMLDivElement>) => {
    const isVisible = useIsSectionInView({ sectionRef, threshold: 0.1, visibleOnce: true });
    const scrollToSection = useScrollToSection();
    const section = useEnclosingJumpMarkSection();

    const [page, setPage] = useState(0);
    const { isLoading, isError, data, isFetching, isPlaceholderData } = useTradeHistoryTableQuery(wikifolioId, page, { enabled: isVisible });

    const handleScrollIntoView = () => {
        const isLastPage = data?.tradeHistory.pageCount && data.tradeHistory.pageCount - 1 === page + 1;

        if (isLastPage && section) {
            scrollToSection(section);
        }
    };

    return {
        isLoading,
        isError,
        data,
        newerBtnProps: {
            onClick: () => setPage(old => Math.max(old - 1, 0)),
            disabled: isFetching || page === 0,
        },
        olderBtnProps: {
            onClick: () => {
                if (!isPlaceholderData && data && data.tradeHistory.pageCount > page) {
                    setPage(old => old + 1);
                }

                handleScrollIntoView();
            },
            disabled: isFetching || data?.tradeHistory.pageCount === 0 || data?.tradeHistory.pageCount === page + 1,
        },
    };
};
